<script setup lang="ts">
type EnumData = App.Base.Data.EnumData;
type DataRequestData = App.DataRequests.Data.DataRequestData;
type ApplicationData = App.Students.Data.ApplicationData;
type StudentUserData = App.Auth.Data.StudentUserData;

import CollegeApplicationDataRequestDialog from '@/domains/data-request/components/student/college-applications/CollegeApplicationDataRequestDialog.vue';

defineProps<{
  dataRequest: DataRequestData;
  application: ApplicationData;
  user: StudentUserData;
  statuses: EnumData[];
}>();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <CollegeApplicationDataRequestDialog
    :application="application"
    :dataRequest="dataRequest"
    :statuses="statuses"
    :user="user"
  />
</template>
